import firebase from "firebase";
import "firebase/firestore";

const hostname = window && window.location && window.location.hostname;
const useEmulator = false; // Enable this to use emulators
export const isTest = false; // Custom flag (optional)

let firebaseConfig = {};

if (isTest) {
    console.log("🔥 Using test config");
    firebaseConfig = {
        apiKey: "AIzaSyDjM24Pf9wSADq5ZOJl142nZZ6uUrwJCyU",
        authDomain: "igo-travel-leads-test.firebaseapp.com",
        databaseURL: "https://igo-travel-leads-test.firebaseio.com",
        projectId: "igo-travel-leads-test",
        storageBucket: "igo-travel-leads-f4ef5.appspot.com",
        messagingSenderId: "511429550861",
        appId: "1:511429550861:web:23763e67b09819eebf0644",
    };
} else {
    console.log("🔥 Using live config");
    firebaseConfig = {
        apiKey: "AIzaSyClU8nmq7vaVG8PKhzW-zuTbquvQc7ns9U",
        authDomain: "igo-travel-leads-f4ef5.firebaseapp.com",
        databaseURL: "https://igo-travel-leads-f4ef5.firebaseio.com",
        projectId: "igo-travel-leads-f4ef5",
        storageBucket: "igo-travel-leads-f4ef5.appspot.com",
        messagingSenderId: "1057279168557",
        appId: "1:1057279168557:web:1ed169e1dd0d07e2",
    };
}

// if (hostname == "localhost" && useEmulator === true) {
//     firebaseConfig[] = {
//         databaseURL: "localhost:8080",
//     };
// }

firebase.initializeApp(firebaseConfig);

if (hostname === "localhost" && useEmulator === true) {
    let db = firebase.firestore();

    db.settings({
        host: "localhost:8080",
        ssl: false,
    });
} else {
    firebase.firestore();
}
if (typeof window !== "undefined") {
    window.__firebase = firebase;
}

export default firebase;
